<template>
    <b-container fluid style="padding:10px">
        <b-card align-content center>
            <b-card-title> {{ post.data.title }}</b-card-title>
            <b-card-sub-title> {{ post.data.author.first_name }} {{ post.data.author.last_name }} </b-card-sub-title>
            <b-card-body v-html="post.data.body"> </b-card-body>
        </b-card>
<!--        <div id="blog-post">-->
<!--            <h1>{{ post.data.title }}</h1>-->
<!--            <h4>{{ post.data.author.first_name }} {{ post.data.author.last_name }}</h4>-->
<!--            <div v-html="post.data.body"></div>-->

<!--            <router-link-->
<!--                    v-if="post.meta.previous_post"-->
<!--                    :to="/blog/ + post.meta.previous_post.slug"-->
<!--                    class="button"-->
<!--            >-->
<!--                {{ post.meta.previous_post.title }}-->
<!--            </router-link>-->
<!--            <router-link-->
<!--                    v-if="post.meta.next_post"-->
<!--                    :to="/blog/ + post.meta.next_post.slug"-->
<!--                    class="button"-->
<!--            >-->
<!--                {{ post.meta.next_post.title }}-->
<!--            </router-link>-->
<!--            <p> {{ this.$route.params.slug }} </p>-->
<!--        </div>-->
    </b-container>
</template>

<script>
    import { butter } from '@/buttercms'
    export default {
        name: 'blog-post',
        data() {
            return {
                post: {}
            }
        },
        methods: {
            getPost() {
                butter.post.retrieve(this.$route.params.slug)
                    .then(res => {
                        this.post = res.data
                    }).catch(res => {
                    console.log(res)
                })
            }
        },
        created() {
            this.getPost()
        }
    }
</script>
